import { useState } from 'react';
import { faMoon, faSquare, faSun } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'framework/button';
import { Checkbox } from 'framework/checkbox';
import { Chip, ChipStatus } from 'framework/chip';
import { CHIP_VARIANT } from 'framework/chip/enums';
import { Input } from 'framework/Input';
import { Modal } from 'framework/modal';
import { Switch } from 'framework/Switch';

import { Grid } from '../../../framework/Grid';
import { GridCellIconSelect, GridFieldCell } from '../../../framework/Grid/cells/GridCell';
import { GridColumn } from '../../../framework/Grid/columns/GridColumn';

interface MyDataItem {
  company_name: string;
  first_name: string;
  last_name: string;
}

const data: MyDataItem[] = [
  { company_name: 'VVVVV Inc', first_name: 'VVVV', last_name: 'VVVV' },
  { company_name: 'AASS Corp', first_name: 'AASS', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Acme Inc', first_name: 'John', last_name: 'Doe' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Acme Inc', first_name: 'John', last_name: 'Doe' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex Corp', first_name: 'Jane', last_name: 'Smith' },
  { company_name: 'Globex ZZZZ', first_name: 'ZZZZ', last_name: 'ZZZZ' },
];

export default () => {
  const [is_open, setOpen] = useState(false);

  const [toggle, setToggle] = useState(true);
  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', margin: 0, gap: '20px' }}>
        <div style={{ display: 'flex', margin: 50 }}>
          <Button onClick={() => setOpen(true)} disabled>
            Button
          </Button>
          <Button disabled>Button</Button>
          <Button left_icon={faMoon} right_icon={faSun}>
            Button
          </Button>
        </div>
        <div style={{ display: 'flex', margin: 50 }}>
          <Switch
            onClick={() => setToggle(!toggle)}
            checked={toggle}
            left_label="Position Off"
            right_label="Position On"
          />
          <Switch
            onClick={() => setToggle(!toggle)}
            checked={toggle}
            circle={24}
            gap={6}
            left_label="Position Off"
            right_label="Position On"
            left_icon={faMoon}
            right_icon={faSun}
          />
          <Switch onClick={() => setToggle(!toggle)} checked={toggle} disabled />
          <Switch onClick={() => setToggle(!toggle)} checked={toggle} />
        </div>
        <div style={{ display: 'flex', margin: 50 }}>
          <Checkbox checked left_label="asdkmasdk asdk" right_label="1203k asd maskd" />
          <Checkbox
            checked={null}
            left_label="asdkmasdk asdk"
            right_label="1203k asd maskd"
            disabled
          />
          <Checkbox left_label="asdkmasdk asdk" right_label="1203k asd maskd" />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', margin: 10, gap: 16 }}>
          <ChipStatus label="Green" variant={CHIP_VARIANT.GREEN} />
          <ChipStatus label="Blue" variant={CHIP_VARIANT.BLUE} />
          <ChipStatus label="Red" variant={CHIP_VARIANT.RED} />
          <ChipStatus label="Yellow" variant={CHIP_VARIANT.YELLOW} />
          <ChipStatus label="Orange" variant={CHIP_VARIANT.ORANGE} />
          <ChipStatus label="Purple" variant={CHIP_VARIANT.PURPLE} />
          <ChipStatus label="Aqua" variant={CHIP_VARIANT.AQUA} />
          <ChipStatus label="Navy" variant={CHIP_VARIANT.NAVY} />
          <ChipStatus label="Light" variant={CHIP_VARIANT.LIGHT} />
          <ChipStatus label="Livid" variant={CHIP_VARIANT.LIVID} />
          <ChipStatus label="Pink" variant={CHIP_VARIANT.PINK} />
          <ChipStatus label="Dark" variant={CHIP_VARIANT.DARK} />
          <ChipStatus label="Platinum" variant={CHIP_VARIANT.PLATINUM} />
          <ChipStatus label="Teal" variant={CHIP_VARIANT.TEAL} />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', margin: 10, gap: 16 }}>
          <Chip label="Green" icon={faSquare} variant={CHIP_VARIANT.GREEN} clear />
          <Chip label="Blue" icon={faSquare} variant={CHIP_VARIANT.BLUE} clear />
          <Chip label="Red" icon={faSquare} variant={CHIP_VARIANT.RED} clear />
          <Chip label="Yellow" icon={faSquare} variant={CHIP_VARIANT.YELLOW} clear />
          <Chip label="Orange" icon={faSquare} variant={CHIP_VARIANT.ORANGE} clear />
          <Chip label="Purple" icon={faSquare} variant={CHIP_VARIANT.PURPLE} clear />
          <Chip label="Aqua" icon={faSquare} variant={CHIP_VARIANT.AQUA} clear />
          <Chip label="Navy" icon={faSquare} variant={CHIP_VARIANT.NAVY} clear />
          <Chip label="Light" icon={faSquare} variant={CHIP_VARIANT.LIGHT} clear />
          <Chip label="Livid" icon={faSquare} variant={CHIP_VARIANT.LIVID} clear />
          <Chip label="Pink" icon={faSquare} variant={CHIP_VARIANT.PINK} clear />
          <Chip label="Dark" icon={faSquare} variant={CHIP_VARIANT.DARK} clear />
          <Chip label="Platinum" icon={faSquare} variant={CHIP_VARIANT.PLATINUM} clear />
          <Chip label="Teal" icon={faSquare} variant={CHIP_VARIANT.TEAL} clear />
        </div>
        <div className="App" style={{ minHeight: 400, width: 'calc(100% - 100px)' }}>
          <Grid
            rows={data}
            summary={[
              { company_name: 'Globex AAA', first_name: 'AAA', last_name: 'AAA' },
              { company_name: 'Globex AAA', first_name: 'AAA', last_name: 'AAA' },
            ]}
          >
            <GridColumn
              label="First"
              sort_field="first_name"
              sort_direction="desc"
              width={100}
              fixed="left"
            >
              <GridFieldCell field="first_name" />
            </GridColumn>
            <GridColumn label="Last" width={100} information="asdas da sd asd">
              <GridFieldCell field="last_name" />
            </GridColumn>
            <GridColumn label="E" text_align="right" width={100} grow={2}>
              <GridFieldCell field="company_name" />
            </GridColumn>
            <GridColumn label="F" width={100} grow={2}>
              <GridFieldCell field="company_name" />
            </GridColumn>
            <GridColumn label="STACKED" text_align="left" fixed="right">
              <GridColumn label="A" width={100}>
                <GridFieldCell field="company_name" />
              </GridColumn>
              <GridColumn label="B" text_align="right" width={100}>
                <GridFieldCell field="company_name" />
              </GridColumn>
              <GridColumn label="C" width={100}>
                <GridFieldCell getValue={(row) => row.company_name} />
              </GridColumn>
            </GridColumn>
            <GridColumn label="Status" width={50} fixed="right">
              <GridCellIconSelect option_key="company" options={[]} />
            </GridColumn>
          </Grid>
        </div>
      </div>
      <Modal identifier="asdasd" is_open={is_open} onClose={() => setOpen(false)}>
        <Modal.Header onClose={() => setOpen(false)}>asdasasd</Modal.Header>
        <Modal.Body>
          <Input label="asdas" />
          <Input label="asdas" />
        </Modal.Body>
        <Modal.Footer>
          <Button>Ok</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
